<script setup>
/* eslint-disable */
import { onMounted, onBeforeUnmount, watch, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useMarketsStore } from '@/stores/markets';
import { useInitializeStore } from '@/stores/initialize';
import PreFixtureDoubleMarket from '@/components/pre_sports/highlights/PreFixtureDoubleMarket.vue';
import LiveFixtureDoubleMarket from '@/components/pre_sports/highlights/LiveFixtureDoubleMarket.vue';
import { SportsData } from '@/stores/Sports';
import OutrightFixture from './highlights/OutrightFixture.vue';
import { useCompetitionsStore } from '@/stores/competitions';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { required } from '@vuelidate/validators';

const router = useRouter();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const initializeStore = useInitializeStore();
const marketsStore = useMarketsStore();
const SportsDataStore = SportsData();
const competitionsStore = useCompetitionsStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const props = defineProps({
	competition: {
		type: Object,
		required: true,
	},
	index: {
		type: Number,
	},
});

const expanded_competition = ref(false);
const competition_fetched = ref(false);
const loading = ref(false);

const expandAndGetFixtures = async (expand = false) => {
	if (!competition_fetched.value) {
		loading.value = true;
	}

	if (expand) {
		expanded_competition.value = expand;
	} else {
		expanded_competition.value = !expanded_competition.value;
	}

	if (!competition_fetched.value) {
		loading.value = true
		// setTimeout(() => {
			dateTimeSportFiltersStore.fetchSingleCompetitionFixtures(props.competition.id).then(() => {
				competition_fetched.value = true
				loading.value = false;
			});

		// }, 120);
	}
}

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}

const competitionFixtures = computed(() => {
	const found_competition = _.find(competitionsStore.competitionFixturesByDate, {'competition_id': String(props.competition.id)});
	if (!found_competition) {
		// expanded_competition.value = false;
		return;
	}
	return found_competition
});

onMounted( () => {
	if (props.index == 0) expandAndGetFixtures(false);
	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}
})

watch(() => dateTimeSportFiltersStore.selected_option, (new_value, old_value) => {
	delete competitionsStore.competition_fixtures[props.competition.id];
	competition_fetched.value = false;
	if (!expanded_competition.value) return;
	expandAndGetFixtures(true);
});

watch(() => props.competition.id, (new_value, old_value) => {
	delete competitionsStore.competition_fixtures[new_value];
	if (props.index == 0) {
		competition_fetched.value = false;
		expandAndGetFixtures(true);
	}
});

</script>

<template>
	<div class="live-bet-dashboard competetion-main round-games-main set_game-outer">
		<div class="bet-dashboard-top">
			<div class="tabing-dashboard">
				<div @click="expandAndGetFixtures(false)" class="competition-tab-title">
					<div class="country-flag">
						<img :src="'/assets' + competition.icon_url" alt="country-flag">
					</div>
					<h6> {{ competition.region_name }} - {{ competition.name }} </h6>
					<div class="takis-gkonias">
						<span>({{ competition.fixtures_count }})</span>
						<div class="icon" :class="{'rotated': expanded_competition}"></div>
					</div>
				</div>


			</div>


		</div>

		<div class="live-tab-info competition-tab-main">
			<div id="competition" class="tab-content competetion-outer-main" v-if="expanded_competition">
				<template v-if="loading">
					<div ref="loadMoreTrigger" class="load-more-sentinel" style="height: 30px;">
						<span>
							<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
						</span>
					</div>
				</template>
				<template v-if="competitionFixtures != undefined">
					<div class="live-info-outer" v-for="(date, date_index) in competitionFixtures.dates" :key="date_index">
						<div class="live-info-inner">
							<div class="live-info-team">

								<div class="live-match competetion-date">
									<div class="live-match-name">
										<h3>{{ date_index }}</h3>
									</div>
								</div>

							</div>

							<div class="full-time-top top-title-dash" v-if="date.some(date => date.outright == false)">
								<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
									<span v-if="odd != ''">{{ odd }}</span>
								</template>
							</div>

							<div class="match-goal-top top-title-dash" v-if="date.some(date => date.outright == false)">
								<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
									<span v-if="odd != ''">{{ odd }}</span>
								</template>
								<span class="bet-column-empty"></span>

							</div>

						</div>

						<!-- Fixtures -->
						<template v-for="fixture in date" :key="fixture.id">
							<template v-if=" initializeStore.screenWidth > 767">
								<div class="live-info-grid">

									<OutrightFixture v-if="fixture.outright"
										:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
										:secondary_overview_market="secondary_overview_market"
										:fixture="fixture"
									/>

									<LiveFixtureDoubleMarket v-if="fixture.live && !fixture.outright"
										:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
										:secondary_overview_market="secondary_overview_market"
										:fixture="fixture"
									/>

									<PreFixtureDoubleMarket v-if="!fixture.live && !fixture.outright"
										:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
										:secondary_overview_market="secondary_overview_market"
										:fixture="fixture"
									/>
								</div>
							</template>
							<template v-else>

								<OutrightFixture v-if="fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="secondary_overview_market"
									:fixture="fixture"
								/>

								<LiveFixtureDoubleMarket v-if="fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="secondary_overview_market"
									:fixture="fixture"
								/>

								<PreFixtureDoubleMarket v-if="!fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="secondary_overview_market"
									:fixture="fixture"
								/>
							</template>
						</template>
					</div>
				</template>
			</div>

		</div>
		<!----- info tab start ------>

	</div>
</template>
<style scoped>
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top {
		display: block !important;
	}

	.dropdown-option-top-2 {
		display: none !important;
	}

}
.live-tav-info {
	scrollbar-width: none !important;
}

.icon {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid var(--input-gray);
    border-bottom: 0;
    transition: transform 0.3s ease;
}

.icon.rotated {
	transform: rotate(180deg);
}

.competetion-section .competetion-main .competition-tab-title {
	grid-template-columns: auto 1fr auto;
}

.takis-gkonias {
	color: var(--white);
	font-size: 11px;
	display: flex;
	align-items: center;
	gap: 4px;
}

@media screen and (min-width: 320px) and (max-width: 767px) {

	:deep(.upcomimg_sport) {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
}

.load-more-sentinel {
	padding-top: 12px;
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.lds-ring {
	display: inline-block;
	position: relative;
	width: 15px;
	height: 15px;
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 15px;
	height: 15px;
	top: 2px;
	margin-right: 10px;
	border: 2px solid var(--white);
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: var(--white) transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}

@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

</style>